import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('featureSet', {
			featureSet: 'getFeatureSet',
		}),
	},
};
